export default __webpack_public_path__ + "images/4493ec9cbcbf4c5247670f98d1084ae9.svg";